import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
            内容导航
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            主题索引
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
            七大主题板块，覆盖日常生活的方方面面，找到你感兴趣的内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {indexItems.slice(0, 4).map((item, index) => (
            <a
              key={index}
              href={`#cards`}
              className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer no-underline"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-6 h-6 flex items-center justify-center rounded-md bg-accent-100 text-accent-600">
                    <i className={`${item.icon} text-xs`}></i>
                  </div>
                  <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                </div>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-2">
                  {item.description}
                </p>
                <span className="text-xs text-foreground-500">{item.count} 篇文章</span>
              </div>
            </a>
          ))}

          {indexItems.slice(4, 7).map((item, index) => (
            <a
              key={index + 4}
              href={`#cards`}
              className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer no-underline lg:col-span-1 sm:col-span-1 col-span-1"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-6 h-6 flex items-center justify-center rounded-md bg-accent-100 text-accent-600">
                    <i className={`${item.icon} text-xs`}></i>
                  </div>
                  <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                </div>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-2">
                  {item.description}
                </p>
                <span className="text-xs text-foreground-500">{item.count} 篇文章</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}